import React, { useMemo, useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import cmtIssueActions from "../../../_actions/_qmsActions/cmtIssueActions";
import CmtIssueDetails from "./CmtIssueDetails";
import CmtIssueThreads from "./CmtIssueThreads";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./cmtIssue.css";
import qmsUserActions from "../../../_actions/_qmsActions/qmsUserActions";
import qmsDocumentActions from "../../../_actions/_qmsActions/qmsDocumentActions";
import cmtStageActions from "../../../_actions/_qmsActions/cmtStageActions";
import cmtCategoryActions from "../../../_actions/_qmsActions/cmtCategoryActions";
import qmsTeamActions from "../../../_actions/_qmsActions/qmsTeamActions";
import qmsFrameworkChangeActions from "../../../_actions/_qmsActions/qmsFrameworkChangeActions";
import { getQmsDocumentLabel } from "../_common/qmsUtilities";
import qmsDocumentTypeActions from "../../../_actions/_qmsActions/qmsDocumentTypeActions";
import { QMS } from "../../../_constants/actionConstants";
import CmtModal_OpenIssue from "./CmtModal_OpenIssue";
import CmtModal_AcknowledgeIssue from "./CmtModal_AcknowledgeIssue";
import qmsActionIsAuthorized from "../_common/qmsAutorize";
import CmtIssueChildren from "./CmtIssueChildren";
import CmtIssueHeaderDetails, { CmtHeaderEditButton } from "./CmtIssueHeaderDetails";
import cmtIssueStageActions from "../../../_actions/_qmsActions/cmtIssueStageActions";
import CmtModal_EditPrimaryOwner from "./CmtModal_EditPrimaryOwner";

const tabs = [
  { tabId: "details", label: "Progress", includeIf: () => true, showCount: false },
  {
    tabId: "childIssues",
    label: "Child Issues",
    includeIf: (parentIssueId) => parentIssueId,
    showCount: true,
    count: (children) => (children || []).length,
  },
  // { tabId: "threads", label: "Bulletin Board", includeIf: () => true, showCount: false },
];

export default function CmtIssue(props) {
  const { tab } = props;

  const dispatch = useDispatch();

  const issue = useSelector((state) => state.qms.openIssues[tab.payload.issueId] || null);
  const qmsUser = useSelector((state) => state.qms.qmsUser || null);
  const qrps = useSelector((state) => state.qms.qmsRolePermissions || []);
  const qmsTeams = useSelector(
    (state) => state.qms.qmsTeams[tab.payload.divisionId] || null
  );
  const proDmsUser = useSelector((state) => state.authentication.user || null);
  const qmsUsersForIssue = useSelector(
    (state) => state.qms.qmsUsersForIssue[tab.payload.issueId] || null
  );

  const ISSUE_SCOPE = useSelector((state) =>
    "ISSUE" in state.qms.permissionScopes ? state.qms.permissionScopes.ISSUE.name : null
  );
  const fetching = useSelector((state) => state.qms.fetching);

  const [selectedTabId, selectTab] = useState("details");
  const [selectedStageId, selectStage] = useState(null);

  const [modalState_open, setModalState_open] = useState({
    showModal: false,
    data: null,
  });
  const toggleModal_open = () =>
    setModalState_open({ ...modalState_open, showModal: !modalState_open.showModal });

  const [modalState_acknowledge, setModalState_acknowledge] = useState({
    showModal: false,
    data: null,
  });
  const toggleModal_acknowledge = () =>
    setModalState_acknowledge({
      ...modalState_acknowledge,
      showModal: !modalState_acknowledge.showModal,
    });

  const [modalState_editPrimaryOwner, setModalState_editPrimaryOwner] = useState({
    showModal: false,
    data: null,
  });
  const toggleModal_editPrimaryOwner = () =>
    setModalState_editPrimaryOwner({
      ...modalState_editPrimaryOwner,
      showModal: !modalState_editPrimaryOwner.showModal,
    });

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(qmsFrameworkChangeActions.getAll(tab.payload.divisionId));
    if (proDmsUser) {
      dispatch(qmsUserActions.getByProDmsUserId(proDmsUser.userId, true));
    }
  }, []);

  useEffect(() => {
    if (tab) {
      dispatch(cmtCategoryActions.getAll(tab.payload.divisionId));
      dispatch(cmtStageActions.getAll(tab.payload.divisionId));
      dispatch(cmtIssueActions.get(tab.payload.issueId));
      dispatch(qmsUserActions.getAllForIssue(tab.payload.issueId));
      dispatch(qmsTeamActions.getAll(tab.payload.divisionId));
      dispatch(qmsDocumentTypeActions.getAll(tab.payload.divisionId));
      dispatch(qmsDocumentActions.getAll(tab.payload.divisionId));
    }
  }, [tab]);

  const editIsAuthorized_tt = useMemo(
    () => issue && qmsActionIsAuthorized(ISSUE_SCOPE, "edit", 2, issue.issueId),
    [issue, ISSUE_SCOPE, qmsUser, qrps]
  );
  const editIsAuthorized_qmr = useMemo(
    () => issue && qmsActionIsAuthorized(ISSUE_SCOPE, "edit", 3, issue.issueId),
    [issue, ISSUE_SCOPE, qmsUser, qrps]
  );
  const detailViewIsAuthorized = useMemo(
    () => issue && qmsActionIsAuthorized(ISSUE_SCOPE, "view", 2, issue.issueId),
    [issue, ISSUE_SCOPE, qmsUser, qrps]
  );

  const getIssueNo = () =>
    issue ? (
      <span className="font-weight-bold">{issue.issueNo}</span>
    ) : fetching ? (
      "Loading..."
    ) : (
      "(N/A)"
    );
  const getInitiatedBy = () => {
    if (issue) {
      const qmsUser = getQmsUserById(issue.initiatedByQmsUserId);
      return qmsUser ? `${qmsUser.fullName} (${qmsUser.distUnit})` : "(N/A)";
    }
    if (fetching) return "Loading...";
    return "(N/A)";
  };
  const getPrimaryOwner = useCallback(() => {
    if (issue) {
      if (!issue.primaryOwnerId) return "(N/A)";
      const qmsTeam = (qmsTeams || []).find(
        (qt) => qt.qmsTeamId === issue.primaryOwnerId
      );
      return qmsTeam ? qmsTeam.name : "(N/A)";
    } else if (fetching) return "Loading...";
    else return "(N/A)";
  }, [issue, qmsTeams]);
  const getInitiatedOn = useCallback(
    () =>
      issue
        ? new Date(issue.initiatedOn).toLocaleDateString()
        : fetching
        ? "Loading..."
        : "(N/A)",
    [issue, fetching]
  );
  const getDeadline = useCallback(
    () =>
      issue ? (
        <span className="issue-deadline">
          {issue.deadline ? new Date(issue.deadline).toLocaleDateString() : "(N/A)"}
        </span>
      ) : fetching ? (
        "Loading..."
      ) : (
        "(N/A)"
      ),
    [issue, fetching]
  );
  const getPriority = useCallback(
    () =>
      issue ? (
        <span className={`issue-priority ${issue.priorityDisplayName || ""}`}>
          {issue.priorityDisplayName}
        </span>
      ) : fetching ? (
        "Loading..."
      ) : (
        "(N/A)"
      ),
    [issue, fetching]
  );
  const getStatus = useCallback(
    () =>
      issue ? (
        <span className={`issue-status ${(issue.status || "").toLowerCase()}`}>
          {issue.status}
        </span>
      ) : fetching ? (
        "Loading..."
      ) : (
        "(N/A)"
      ),
    [issue, fetching]
  );
  const getFollowerCount = useCallback(
    () => (issue ? (issue.followerQmsUserIds || []).length : 0),
    [issue]
  );
  const daysSinceInit = useCallback(
    () =>
      Math.floor(
        issue
          ? (new Date() - new Date(issue.initiatedOn || 0)) / (1000 * 60 * 60 * 24)
          : 0
      ),
    [issue]
  );

  const getQmsUserById = useCallback(
    (qmsUserId) => {
      if (!qmsUserId) return null;
      const qmsUser = (qmsUsersForIssue || []).find((qu) => qu.qmsUserId === qmsUserId);
      return qmsUser || null;
    },
    [qmsUsersForIssue]
  );

  const handleClick_acknowledge = (e) => {
    e.preventDefault();
    if (issue && qmsUser)
      setModalState_acknowledge({
        showModal: true,
        data: {
          tabId: tab.tabId,
          divisionId: tab.payload.divisionId,
          issueId: issue.issueId,
          qmsUserId: qmsUser.qmsUserId,
        },
      });
  };

  const handleClick_closeIssue = async (e) => {
    e.preventDefault();
    if (issue && qmsUser) {
      dispatch({
        type: QMS.ISSUE.UPDATE_CLIENT,
        issueId: issue.issueId,
        fieldsToUpdate: {
          isClosed: true,
          closedByQmsUserId: qmsUser.qmsUserId,
        },
      });
      await dispatch(cmtIssueActions.close(issue.issueId));
      if (selectedStageId && selectedStageId !== "initiated")
        dispatch(cmtIssueStageActions.get(issue.issueId, selectedStageId));
      dispatch(cmtIssueActions.reloadParent(issue.parentIssueId));
      dispatch(cmtIssueActions.getAll(tab.payload.divisionId));
    }
  };

  const handleClick_open = (e) => {
    e.preventDefault();
    if (issue && qmsUser)
      setModalState_open({
        showModal: true,
        data: {
          tabId: tab.tabId,
          divisionId: tab.payload.divisionId,
          issueId: issue.issueId,
          qmsUserId: qmsUser.qmsUserId,
        },
      });
  };

  const handleClick_reopen = async (e) => {
    dispatch({
      type: QMS.ISSUE.UPDATE_CLIENT,
      issueId: issue.issueId,
      fieldsToUpdate: {
        isOpen: true,
        openedByQmsUserId: qmsUser.qmsUserId,
        stagePrepopulationType: "none",
      },
    });
    await dispatch(cmtIssueActions.open(issue.issueId));
    if (selectedStageId && selectedStageId !== "initiated")
      dispatch(cmtIssueStageActions.get(issue.issueId, selectedStageId));
    dispatch(cmtIssueActions.getAll(tab.payload.divisionId));
  };

  const renderStaleAlert = () =>
    daysSinceInit() > 4 && (
      <div className="alert alert-warning mb-2 p-1 w-100">
        <div className="d-flex flex-row">
          <div className="my-auto align-middle">
            <FontAwesomeIcon icon="info-circle" className="fa-fw mr-2" />
          </div>
          <div className="flex-grow-1 my-auto">
            This issue is {daysSinceInit()} days old.
          </div>
        </div>
      </div>
    );

  const renderHeaderSummary = () => (
    <div className="card flex-grow-1">
      <div className="card-body p-2">
        <ul className="list-group-flush border-0 pl-0 mb-2">
          <li className="list-group-item py-0 pl-1 border-0">
            <div className="row">
              <div className="col-4 pr-1 font-weight-bold">Issue No:</div>
              <div className="col-8 pl-1">{getIssueNo()}</div>
            </div>
          </li>
          <li className="list-group-item py-0 pl-1 border-0">
            <div className="row">
              <div className="col-4 pr-1 font-weight-bold">Initiated By:</div>
              <div className="col-8 pl-1">{getInitiatedBy()}</div>
            </div>
          </li>
          <li className="list-group-item py-0 pl-1 border-0">
            <div className="row">
              <div className="col-4 pr-1 font-weight-bold">Primary Owner:</div>
              <div className="col-8 pl-1">
                {getPrimaryOwner()}
                {issue && !issue.isClosed && editIsAuthorized_qmr && (
                  <CmtHeaderEditButton
                    buttonId="editPrimaryOwner"
                    handleClick={() =>
                      setModalState_editPrimaryOwner({
                        showModal: true,
                        data: {
                          divisionId: tab.payload.divisionId,
                          issueId: issue.issueId,
                          primaryOwnerId: issue.primaryOwnerId,
                        },
                      })
                    }
                  />
                )}
              </div>
            </div>
          </li>
          <li className="list-group-item py-0 pl-1 border-0">
            <div className="row">
              <div className="col-4 pr-1 font-weight-bold">Initiated On:</div>
              <div className="col-8 pl-1">{getInitiatedOn()}</div>
            </div>
          </li>
          <li className="list-group-item py-0 pl-1 border-0">
            <div className="row">
              <div className="col-4 pr-1 font-weight-bold">Deadline:</div>
              <div className="col-8 pl-1">{getDeadline()}</div>
            </div>
          </li>
          <li className="list-group-item py-0 pl-1 border-0">
            <div className="row">
              <div className="col-4 pr-1 font-weight-bold">Priority:</div>
              <div className="col-8 pl-1">{getPriority()}</div>
            </div>
          </li>
          <li className="list-group-item py-0 pl-1 border-0">
            <div className="row">
              <div className="col-4 pr-1 font-weight-bold">Status:</div>
              <div className="col-8 pl-1">{getStatus()}</div>
            </div>
          </li>
        </ul>
        <hr className="my-1" />
        <div className="d-flex flex-row flex-wrap mt-2">
          {issue && editIsAuthorized_qmr && (
            <>
              {!issue.isAcknowledged && (
                <button
                  id="acknowledgeIssue"
                  name="acknowledgeIssue"
                  onClick={handleClick_acknowledge}
                  className="btn btn-primary py-1 mr-2"
                >
                  Acknowledge
                </button>
              )}
              {!issue.isOpen && (
                <button
                  id="openIssue"
                  name="openIssue"
                  onClick={issue.isClosed ? handleClick_reopen : handleClick_open}
                  className="btn btn-success py-1 mr-2"
                >
                  {issue.isClosed ? "Reopen" : "Open"}
                </button>
              )}
              {issue.isOpen && (
                <button
                  id="closeIssue"
                  name="closeIssue"
                  onClick={handleClick_closeIssue}
                  className="btn btn-danger py-1 mr-2"
                >
                  Close
                </button>
              )}
            </>
          )}
          <button
            id="followers"
            name="follower"
            onClick={() => {}}
            className="btn btn-link py-1 mr-0"
          >
            {getFollowerCount()}
            {" Followers"}
          </button>
        </div>
      </div>
    </div>
  );

  const renderTabContent = () => {
    switch (selectedTabId) {
      case "details":
        return (
          <CmtIssueDetails
            issueId={tab.payload.issueId}
            tabId={tab.tabId}
            editIsAuthorized_tt={editIsAuthorized_tt}
            editIsAuthorized_qmr={editIsAuthorized_qmr}
            detailViewIsAuthorized={detailViewIsAuthorized}
            selectedStageId={selectedStageId}
            selectStage={selectStage}
          />
        );
      case "childIssues":
        return (
          <CmtIssueChildren
            issue={issue}
            tabId={tab.tabId}
            detailViewIsAuthorized={detailViewIsAuthorized}
          />
        );
      // case "threads":
      //   return <CmtIssueThreads />;
      default:
        return;
    }
  };

  return (
    <>
      <div className="row mx-0">
        <div className="col-12 px-2">
          <div className="d-flex flex-row w-100 mt-2">{renderStaleAlert()}</div>
          <div className="d-flex flex-row w-100 mb-2">
            <div className="d-flex flex-column mr-1 issue-header-summary">
              {renderHeaderSummary()}
            </div>
            <div className="d-flex flex-column ml-1 issue-header-details">
              <CmtIssueHeaderDetails
                issueId={tab.payload.issueId}
                divisionId={tab.payload.divisionId}
                editIsAuthorized_qmr={editIsAuthorized_qmr}
              />
            </div>
          </div>
          <CmtIssueTabs selectTab={selectTab} selectedTabId={selectedTabId} issue={issue}>
            {renderTabContent()}
          </CmtIssueTabs>
        </div>
      </div>
      {modalState_open.showModal && (
        <CmtModal_OpenIssue
          modalState={modalState_open}
          toggleModal={toggleModal_open}
          selectedStageId={selectedStageId}
        />
      )}
      {modalState_acknowledge.showModal && (
        <CmtModal_AcknowledgeIssue
          modalState={modalState_acknowledge}
          toggleModal={toggleModal_acknowledge}
        />
      )}
      {modalState_editPrimaryOwner.showModal && (
        <CmtModal_EditPrimaryOwner
          modalState={modalState_editPrimaryOwner}
          toggleModal={toggleModal_editPrimaryOwner}
        />
      )}
    </>
  );
}

function CmtIssueTabs(props) {
  const { selectTab, selectedTabId, issue } = props;

  const renderTab = (tab) => {
    return (
      <li key={tab.tabId} className="nav-item">
        <div
          className={`nav-link border border-secondary border-bottom-0 pointer-cursor py-1 ${
            tab.tabId === selectedTabId ? "active admin-tab--border" : ""
          }`}
          id={tab.tabId + "_tab"}
          data-toggle="tab"
          role="tab"
          onClick={() => selectTab(tab.tabId)}
        >
          {tab.label}
          {tab.showCount && (
            <span className="badge badge-secondary ml-2">
              {issue ? tab.count(issue.childIssues) : 0}
            </span>
          )}
        </div>
      </li>
    );
  };

  return (
    <>
      <ul className="nav nav-tabs border-0" role="tablist">
        {tabs
          .filter((t) => t.includeIf(issue ? !issue.parentIssueId : true))
          .map((tab) => renderTab(tab))}
      </ul>
      <div className="tab-content pa-tab-content">
        <div
          className="tab-pane fade show active border border-secondary pa-tab-pane p-3"
          role="tabpanel"
        >
          {props.children}
        </div>
      </div>
    </>
  );
}
